export default {
  "LocationAgreeModal.Title": "位置情報の利用に同意する",
  "LocationAgreeModal.TextTop":
    "ドコモおよびNTTドコモビジネス株式会社は、以下に記載のドコモまたはNTTドコモビジネス株式会社が取得しているお客さまの位置情報を、以下に記載の利用目的を達成するために必要な範囲で利用します",
  "LocationAgreeModal.GettingLocaleTitle": "【利用する位置情報】",
  "LocationAgreeModal.GettingLocaleContent":
    "移動体端末の所持者の所在を表す場所を示す情報です。例として、端末のGPS機能の他、Wi-Fiまたはその他の近距離無線通信技術、携帯電話基地局により測位される位置情報（位置登録情報を含みますが、これに限りません）などが含まれます",
  "LocationAgreeModal.PurposeTitle": "【利用目的】",
  "LocationAgreeModal.PurposeList1":
    "ドコモやドコモの連結子会社および持分法適用会社ならびにNTTの連結子会社および持分法適用会社で利用可能なクーポンなどの特典の進呈、ドコモまたはNTTドコモビジネス株式会社が適切と判断したさまざまな商品・サービス・キャンペーン・イベント（ドコモまたはNTTドコモビジネス株式会社以外の第三者のものを含みます）に関する情報提供や広告の表示・配信のため",
  "LocationAgreeModal.PurposeList2":
    "ドコモまたはNTTドコモビジネス株式会社の商品やサービスの販売・利用状況の調査および分析、ドコモまたはNTTドコモビジネス株式会社の商品やサービスの運用・向上、新商品や新サービスの企画、アンケート調査その他マーケティング分析のため",
  "LocationAgreeModal.PurposeAsterisk1":
    "本同意事項で同意いただいた上記の利用目的での位置情報の利用の停止を希望する場合、お客さまのパーソナルデータダッシュボード上の「位置情報利用の管理」画面にて「位置情報をドコモおよびNTTドコモビジネス株式会社が利用することに同意」をタップしてオフにすることにより設定を変更してください。なお、設定変更が反映される前に取得された位置情報は利用されることがあることを予めご了承ください",
  "LocationAgreeModal.PurposeAsterisk2":
    "本同意事項への同意の有無にかかわらず、ドコモおよびNTTドコモビジネス株式会社は、電気通信役務の提供に必要な範囲など法令により認められる範囲で、または個々のサービス・アプリなどにおいてお客さまの同意を得ることにより、位置情報を取得・利用しています。なお、個々のサービス・アプリなどにおいて独自に利用する位置情報の利用停止は個々のサービス・アプリなどにて指定する方法にて実施ください",
}
